"use strict";

// adds ' (**Custom Size**)' to sizeText
module.exports = function (accumulator) {
  var addition = '(**Custom Size**)';
  return accumulator + ' ' + addition;
};